import * as React from "react"

import { cn } from "../../cn"
import { Tooltip } from "../Tooltip/Tooltip"

const DEFAULT_BETA_TOOLTIP =
  "This feature is in beta and might still have bugs."

export type BetaBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  tooltipContent?: React.ReactNode
}

/**
 * "beta" affordance for features still in beta. Rendered as a plain muted
 * lowercase label (NOT a colored chip) so every beta tag across the product —
 * the Custom SQL metric picker, the suspect label queue, the workspace
 * switcher — reads identically. This is the single source of truth for the beta
 * tag; do not reintroduce per-surface inline beta spans or a colored variant.
 * Every beta tag shows the house hover copy by default, which can be overridden
 * with tooltipContent when a surface needs different guidance.
 */
const BetaBadge = React.forwardRef<HTMLSpanElement, BetaBadgeProps>(
  ({ className, tooltipContent = DEFAULT_BETA_TOOLTIP, ...props }, ref) => (
    <Tooltip content={tooltipContent}>
      <span
        ref={ref}
        className={cn(
          "shrink-0 text-xs font-medium text-coval-text-muted",
          className,
        )}
        {...props}
      >
        beta
      </span>
    </Tooltip>
  ),
)

BetaBadge.displayName = "BetaBadge"

export { BetaBadge }
